import { FileText, Download, File } from "lucide-react";

const TYPE_BADGE = {
  contrato: { label: "Contrato", cls: "bg-blue-100 text-blue-700" },
  factura: { label: "Factura", cls: "bg-amber-100 text-amber-700" },
};

function formatDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("es-ES", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export default function DocumentsTab({ documents }) {
  if (!documents || documents.length === 0) {
    return (
      <div className="text-center py-16">
        <FileText size={40} className="mx-auto text-gray-300 mb-3" />
        <p className="text-gray-400">No hay documentos registrados</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-gray-50 text-gray-500 text-xs uppercase">
          <tr>
            <th className="text-left px-4 py-3 font-medium">Nombre</th>
            <th className="text-left px-4 py-3 font-medium">Tipo</th>
            <th className="text-left px-4 py-3 font-medium">Fecha</th>
            <th className="text-right px-4 py-3 font-medium">Archivo</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {documents.map((doc) => {
            const badge = TYPE_BADGE[doc.doc_type] || {
              label: doc.doc_type,
              cls: "bg-gray-100 text-gray-600",
            };
            return (
              <tr key={doc.id} className="hover:bg-gray-50">
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2">
                    <File size={14} className="text-gray-400 shrink-0" />
                    <span className="text-gray-900">{doc.name}</span>
                  </div>
                </td>
                <td className="px-4 py-3">
                  <span
                    className={`px-2 py-0.5 text-xs font-medium rounded-full ${badge.cls}`}
                  >
                    {badge.label}
                  </span>
                </td>
                <td className="px-4 py-3 text-gray-600">
                  {formatDate(doc.date)}
                </td>
                <td className="px-4 py-3 text-right">
                  {doc.file_url ? (
                    <a
                      href={doc.file_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 text-indigo-600 hover:text-indigo-800 text-xs font-medium"
                    >
                      <Download size={13} />
                      Descargar
                    </a>
                  ) : (
                    <span className="text-gray-400 text-xs">—</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
